"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _constant = require("./constant");
var _thumbsupdown = _interopRequireDefault(require("./thumbsupdown.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "ThumbsUpDown__IconContainer",
  componentId: "sc-1t0mysy-0"
})(["display:flex;"]);
var ThumbUpIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "ThumbsUpDown__ThumbUpIconWrapper",
  componentId: "sc-1t0mysy-1"
})(["display:flex;justify-content:center;align-items:center;margin-right:", ";border:", ";border-radius:", ";box-sizing:", ";background:", ";width:44px;height:44px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.XSmall;
}, function (props) {
  return props.thumbupselected ? "1px solid ".concat(props.theme.colors.secondaryBlue) : 'none';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.normal;
}, function (props) {
  return props.thumbupselected ? 'border-box' : 'none';
}, function (props) {
  return props.thumbupselected ? props.theme.colors.secondaryLight : props.theme.colors.greyLighter;
});
var ThumbDownIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "ThumbsUpDown__ThumbDownIconWrapper",
  componentId: "sc-1t0mysy-2"
})(["display:flex;justify-content:center;align-items:center;margin-left:", ";border:", ";box-sizing:", ";border-radius:", ";background:", ";width:44px;height:44px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.XSmall;
}, function (props) {
  return props.thumbdownselected ? "1px solid ".concat(props.theme.colors.secondaryBlue) : 'none';
}, function (props) {
  return props.thumbdownselected ? 'border-box' : 'none';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius.normal;
}, function (props) {
  return props.thumbdownselected ? props.theme.colors.secondaryLight : props.theme.colors.greyLighter;
});
var getPadding = function getPadding(props) {
  return props.theme.space.XSmall;
};
var ThumbsUpDown = function ThumbsUpDown(props) {
  var theme = props.theme,
    isMobile = props.isMobile,
    onChange = props.onChange,
    keyIndex = props.keyIndex;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var handleClick = function handleClick(option) {
    return function () {
      setSelected(option);
      var optiondId = option === _constant.ICONS.THUMBS_UP ? _constant.ICONS.THUMBS_UP_VALUE : _constant.ICONS.THUMBS_DOWN_VALUE;
      onChange(option, optiondId, keyIndex);
    };
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(IconContainer, {
      isMobile: isMobile,
      theme: themeContext
    }, /*#__PURE__*/_react.default.createElement(ThumbUpIconWrapper, {
      onChange: handleClick,
      onClick: handleClick(_constant.ICONS.THUMBS_UP),
      thumbupselected: selected === _constant.ICONS.THUMBS_UP
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: selected === _constant.ICONS.THUMBS_UP ? _constant.ICON_TYPE.selected.color : _constant.ICON_TYPE.normal.color,
      icon: _constant.ICONS.THUMBS_UP,
      padding: getPadding,
      fontsize: _constant.ICON_TYPE.normal.size,
      theme: theme
    })), /*#__PURE__*/_react.default.createElement(ThumbDownIconWrapper, {
      onChange: handleClick,
      onClick: handleClick(_constant.ICONS.THUMBS_DOWN),
      thumbdownselected: selected === _constant.ICONS.THUMBS_DOWN
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: selected === _constant.ICONS.THUMBS_DOWN ? _constant.ICON_TYPE.selected.color : _constant.ICON_TYPE.normal.color,
      icon: _constant.ICONS.THUMBS_DOWN,
      padding: getPadding,
      fontsize: _constant.ICON_TYPE.normal.size,
      theme: theme
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
ThumbsUpDown.propTypes = _thumbsupdown.default.PropTypes;
ThumbsUpDown.defaultProps = _thumbsupdown.default.DefaultProps;
var _default = ThumbsUpDown;
exports.default = _default;